import round from 'lodash/round'

export const formatDigitsWithSpaces = (digits) => {
  const value = String(digits).replace(/[^0-9.-]/g, '') // Keep minus sign and remove other non-numeric characters

  // Handle negative numbers
  const isNegative = value.startsWith('-')
  const numberPart = isNegative ? value.slice(1) : value // Remove minus sign for now

  const [integerPart, decimalPart] = numberPart.split('.') // Split into integer and decimal parts

  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Add spaces to integer part

  const result = decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger // Rejoin if decimal part exists
  return isNegative ? `-${result}` : result // Add back minus sign if necessary
}

export const roundThreeDigitsAfterDots = (digits) => {
  if (!digits) return digits
  const convertDigits = Number(digits)

  return roundDigitsAfterDots(convertDigits, 3)
}

export const roundTwoDigitsAfterDots = (digits) => {
  return roundDigitsAfterDots(digits, 2)
}

export const roundDigitsAfterDots = (digits, length) => {
  if (!digits) return digits

  return round(digits, length)
}
